export type { ModalProps } from "@components/contracts/Modal.types";
export { RsuiteModal } from "./Modal.adapter";
